/* eslint-disable react/forbid-prop-types,react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";
import {filterHTML} from "../../helpers/filters";
import './SiteIntroPage.scss';

const SiteIntroPage = ({entityLabel, entityMetatags, body, fieldBackgroundImageMedia}) => {

    // Get title from metatags, fall back to entityLabel.
    let title = entityMetatags.filter(metaTag => metaTag.key === 'title');
    if (Object.keys(title).length && title[0]) {
        title = title[0].value;
    } else {
        title = `${entityLabel} | MarketAxess`;
    }

    return (
        <div className="siteintroPage">
            <Helmet>
                {title && (
                    <title>{title}</title>
                )}
                {entityMetatags.filter(metaTag => metaTag.key !== 'title' && !metaTag.key.includes('og:')).map(metaTag => (
                    <meta name={metaTag.key} content={metaTag.value} key={`standardMeta_${metaTag.key}`}/>
                ))}
                {entityMetatags.filter(metaTag => metaTag.key.includes('og:')).map(metaTag => (
                    <meta property={metaTag.key} content={metaTag.value} key={`opengraphMeta_${metaTag.key}`}/>
                ))}
            </Helmet>

            <div className="main">
                {fieldBackgroundImageMedia.entity && fieldBackgroundImageMedia.entity.fieldMediaImage && fieldBackgroundImageMedia.entity.fieldMediaImage.url && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: `url("${fieldBackgroundImageMedia.entity.fieldMediaImage.url}") no-repeat center center/cover`
                    }}/>
                )}
                <div className="container">
                    {body && body.processed && (
                        <div dangerouslySetInnerHTML={{__html: filterHTML(body.processed)}} />
                    )}
                </div>
            </div>
        </div>
    );
};

SiteIntroPage.propTypes = {
    entityLabel: PropTypes.string,
    body: PropTypes.object,
    entityMetatags: PropTypes.object,
    fieldBackgroundImageMedia: PropTypes.object,
};

SiteIntroPage.defaultProps = {
    entityLabel: '',
    body: {processed: ''},
    entityMetatags: {},
    fieldBackgroundImageMedia: {},
};

export default SiteIntroPage;



// WEBPACK FOOTER //
// ./frontend/pages/SiteIntro/SiteIntroPage.jsx